import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getFabric, addFabric, deleteFabric, updateFabric } from "../../redux/actions/fabric.action";
import { getDefaultCompany, getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, updateCompanyAccess, deleteCompanyAccess, getAllCompany, createCompanyAccess } from "../../redux/actions/companyAccess"
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { ReadCookie } from "../../utils/readCookie";
import Tables from "../../components/Table/Tables"
import { Button, Row, Col, Form, Input, Checkbox, Select, Tabs, Tooltip, Popconfirm, Modal, Divider } from 'antd';
import { CloseCircleOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { logColumns, fabricColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { getFabricClass } from '../../redux/actions/FabricClass.action';
import { getFabricType } from '../../redux/actions/FabricType.action';
import { getFabricUsable } from '../../redux/actions/FabricUsable.action';
import { getFabricClass2 } from '../../redux/actions/FabricClass2.action';
import { getFabricComposition } from '../../redux/actions/FabricComposition.action';
import { TabTitle } from '../../utils/GeneralFunction';
const { TabPane } = Tabs;
const { Option } = Select;

export default function Fabric({ token }) {
    TabTitle("Fabric")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const FabricNameInput = useRef(null);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [fabricObj, setFabricObj] = useState(null);
    const [fabricClassObj, setFabricClassObj] = useState(null);
    const dispatch = useDispatch();
    const { fabric, getDemoDefaultCompany, companyAccess, companyAll, log, userRights, fabricClass, fabricClass2, fabricType, fabricUsable, fabricComposition } = useSelector(state => state)
    
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [fabricName, setFabricName] = useState('');
    const [fabricClassID, setFabricClassID] = useState('');
    const [fabricClassID2, setFabricClassID2] = useState('');
    const [fabricTypeID, setFabricTypeID] = useState('');
    const [fabricUsableID, setFabricUsableID] = useState('');
    const [fabricCompositionID, setFabricCompositionID] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

    const handleEdit = (record, type) => {
        if (type === "active") {
            dispatch(updateCompanyAccess(token, record)).then((res) => dispatch(getCompanyAccess(token, fabricObj.fabric_id, menuId)));
        }
        if (type === "delete") {
            dispatch(deleteCompanyAccess(token, record)).then((res) => dispatch(getCompanyAccess(token, fabricObj.fabric_id, menuId)));
        }
    }

    const createAssignCompany = (record) => {
        dispatch(createCompanyAccess(token, record, fabricObj.fabric_id, menuId)).then((res) => dispatch(getCompanyAccess(token, fabricObj.fabric_id, menuId)))
    }

    const companyCol = [
        { title: 'Company ID', dataIndex: 'company_id', key: 'company_id', },
        { title: 'Company Name', dataIndex: 'company_name', key: 'company_name', },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Minimize" color="#fbfbfb"  >
                    </Tooltip>
                    {
                        record.is_active ?
                            <Tooltip title="Activate" color="#fbfbfb"  ><CheckCircleOutlined className='color-green' onClick={() => handleEdit(record, "active")} /></Tooltip> : <Tooltip title="Deactivate" color="#fbfbfb"  ><CloseCircleOutlined className="color-red" onClick={() => handleEdit(record, "active")} /></Tooltip>}
                    {
                        dCompanyId === record.company_id.toString() ?
                            <Tooltip title="Default company can't be deleted" color="#fbfbfb"  >
                                <DeleteOutlined className='delete-Button' disabled twoToneColor="red" />
                            </Tooltip> :
                            <Tooltip title="delete" color="#fbfbfb"  >
                                <Popconfirm placement="top" title={"Are you sure to delete this?"} onConfirm={() => handleEdit(record, "delete")} okText="Yes" cancelText="No">
                                    <DeleteOutlined className='delete-Button' twoToneColor="red" />
                                </Popconfirm>
                            </Tooltip>
                    }
                </>
            ),
        },
    ];
    const companyAccessCol = [
        { title: 'ID', dataIndex: 'company_id', key: 'company_id', },
        { title: 'Company Name', dataIndex: 'company_name', key: 'company_name', },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    {
                        companyAccess?.payload?.data?.find(m => m.company_id === record?.company_id) ?
                            <>
                                <Tooltip title="Already assigned" color="#fbfbfb"  >
                                    <Button className='modalActionBTN' disabled shape='circle' icon={<CheckCircleOutlined className="color-red" />} />
                                </Tooltip>
                            </> :

                            <Tooltip title="Click to assign" color="#fbfbfb"  >
                                <Button className='modalActionBTN' onClick={() => createAssignCompany(record)} shape='circle' icon={<CloseCircleOutlined className='color-green' />} />
                            </Tooltip>
                    }
                </>
            ),
        },
    ];

    
    
    

    useEffect(() => {
        dispatch(getFabric(token, menuId))
        dispatch(getFabricClass(token, menuId))
        dispatch(getFabricClass2(token, menuId))
        dispatch(getFabricType(token, menuId))
        dispatch(getFabricUsable(token, menuId))
        dispatch(getFabricComposition(token, menuId))
    }, [token]);

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])


    useEffect(() => {

        if (fabricObj) {


            setFormState('view')
            form.setFieldsValue({
                id: fabricObj.fabric_id,
                fabric: fabricObj.fabric_name,
                fabricClass: fabricObj.fabric_class_id1 === null ? "N/A" : fabricObj.fabric_class_id1,
                fabricClass2: fabricObj.fabric_class_id2 === null ? "N/A" : fabricObj.fabric_class_id2,
                fabricType: fabricObj.fabric_type_id === null ? "N/A" : fabricObj.fabric_type_id,
                fabricUsable: fabricObj.fabric_useable_id === null ? "N/A" : fabricObj.fabric_useable_id,
                fabricComposition: fabricObj.fabric_composition_id === null ? "N/A" : fabricObj.fabric_composition_id,
                active: fabricObj.is_active
            });
            setFabricName(fabricObj.fabric_name)
            setFabricClassID(fabricObj.fabric_class_id1)
            setFabricClassID2(fabricObj.fabric_class_id2)
            setFabricTypeID(fabricObj.fabric_type_id)
            setFabricUsableID(fabricObj.fabric_useable_id)
            setFabricCompositionID(fabricObj.fabric_composition_id)
            setCheck(fabricObj.is_active)
            dispatch(getCompanyAccess(token, fabricObj.fabric_id, menuId))
        }

    }, [fabricObj]);

    useEffect(() => {
        if (fabricName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [fabricName])

    const showModal = () => {
        dispatch(getAllCompany(token));
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const handleTab = (key) => {
        if (key === "logs") {
            
            dispatch(getLog(token, { inv_fabric: "inv_fabric", admin_company_entity_access: "admin_company_entity_access" }))
        }
    }

    const formSave = () => {
        if (formState === "add") {
            dispatch(addFabric(token, { fabricName, check, fabricClassID, fabricClassID2, fabricTypeID, fabricUsableID, fabricCompositionID }, menuId)).then((res) => {
                if (res.type === "ADD_FABRIC_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                
                
                if (res.type === "ADD_FABRIC_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    dispatch(createCompanyAccess(token, data, res?.payload.p_internal_id[0].p_internal_id, menuId)).then((res) => dispatch(getCompanyAccess(token, fabricObj.fabric_id, menuId)))
                    notification("success", "Fabric Created", "Fabric created successfully!");
                    form.setFieldsValue({
                        fabric: "",
                        fabricClass: "",
                        fabricClass2: "",
                        fabricType: "",
                        fabricUsable: "",
                        fabricComposition: "",
                    })
                    setFormState("")
                    
                    setFabricName("")
                    setFabricClassID("")
                    setFabricClassID2("")
                    setFabricTypeID("")
                    setFabricUsableID("")
                    setFabricCompositionID("")
                    setFabricObj(null)
                }
                dispatch(getFabric(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updateFabric(token, { fabricName, check, fabricClassID, fabricClassID2, fabricTypeID, fabricUsableID, fabricCompositionID }, fabricObj.fabric_id)).then((res) => {
                if (res.type === "UPDATE_FABRIC_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_FABRIC_SUCCESS") {
                    notification("success", "Fabric Updated", "Record updated successfully")
                }
                dispatch(getFabric(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (fabricObj) {
            dispatch(deleteFabric(token, fabricObj.fabric_id)).then((res) => {
                if (res.type === "DELETE_FABRIC_SUCCESS") {
                    notification("success", "Fabric Deleted", "Fabric deleted successfully!");
                }
                if (res.type === "DELETE_FABRIC_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    fabric: ""
                })
                
                setFabricName("")
                setFabricClassID("")
                setFabricClassID2("")
                setFabricTypeID("")
                setFabricUsableID("")
                setFabricCompositionID("")
                setFabricObj(null)
                setFormState('')
                dispatch(getFabric(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            FabricNameInput.current.focus();
            form.setFieldsValue({
                fabric: "",


            })
            setCheck(true)
            setFabricName("")
            setFabricClassID("")
            setFabricClassID2("")
            setFabricTypeID("")
            setFabricUsableID("")
            setFabricCompositionID("")
            setFabricObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }



    return (
        <div className='styleContainer'>
            <div className='styleBody h-100'  >
                <PageHeader title={"Fabric"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="fabric" fabricObj={setFabricObj} scrollX={"20rem"} scroll={602} perPage={25} source={fabric?.payload?.data} col={fabricColumns} paginate load={fabric.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 8 }}
                                        >
                                            <div className='customRow styleFormUpper d-flex flex-row flex-wrap justify-content-start' >
                                                {fabricObj !== null && !(formState === "add") &&
                                                    <div className='customCols slc m-0 width400'>
                                                        <Form.Item
                                                            name="id"
                                                            label="ID"
                                                            initialValue={form.getFieldValue().id}
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Input size='small' className='styleInput id-field-style' readOnly />

                                                        </Form.Item>
                                                    </div>
                                                }


                                                <Form.Item
                                                    className='width400'
                                                    label="Fabric"
                                                    name="fabric"
                                                    labelCol={{ span: 10 }}
                                                    wrapperCol={{ span: 14 }}
                                                    initialValue={form.getFieldValue().style}
                                                >

                                                    <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={FabricNameInput} onChange={(e) => setFabricName(e.target.value)} className='styleInput' />
                                                </Form.Item>


                                                <div className='customCol slc width400'>
                                                    <div className="relative" >
                                                        <Form.Item rules={[{ required: true, message: "Fabric Class is required" }]} name="fabricClass"
                                                            label="Fabric Class"
                                                            
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}

                                                        >
                                                            <Select
                                                                size="small"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                                
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                                defaultValue={formState === "edit" ? form.getFieldValue().fabricClass : null}
                                                                onChange={(e) => setFabricClassID(Number(e))}
                                                                className="w-100"

                                                            >
                                                                {
                                                                    fabricClass?.payload?.data.map((item) => {
                                                                        return <Option disabled={!item.is_active} key={item.fabric_class_id} value={item.fabric_class_id}>{item.fabric_class_name}</Option>
                                                                    })
                                                                }
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                                <div className='customCol slc width400'>
                                                    <div className="relative" >
                                                        <Form.Item rules={[{ required: true, message: "Fabric Class  2 is required" }]} name="fabricClass2"
                                                            label="Fabric Class 2"

                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Select
                                                                size="small"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                                
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                                defaultValue={formState === "edit" ? form.getFieldValue().fabricClass : null}
                                                                onChange={(e) => setFabricClassID2(Number(e))}
                                                                className="w-100"

                                                            >
                                                                {
                                                                    fabricClass2?.payload?.data.map((item) => {
                                                                        return <Option disabled={!item.is_active} key={item.fabric_class_id2} value={item.fabric_class_id2}>{item.fabric_class_name2}</Option>
                                                                    })
                                                                }
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                                <div className='customCol slc width400'>
                                                    <div className="relative" >
                                                        <Form.Item rules={[{ required: true, message: "Fabric Type is required" }]} name="fabricType"
                                                            label="Fabric Type"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Select
                                                                size="small"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                                
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                                defaultValue={formState === "edit" ? form.getFieldValue().fabricType : null}
                                                                onChange={(e) => setFabricTypeID(Number(e))}
                                                                className="w-100"
                                                            
                                                            >
                                                                {
                                                                    fabricType?.payload?.data.map((item) => {
                                                                        return <Option disabled={!item.is_active} key={item.fabric_type_id} value={item.fabric_type_id}>{item.fabric_type_name}</Option>
                                                                    })
                                                                }
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                                <div className='customCol slc width400'>
                                                    <div className="relative" >
                                                        <Form.Item rules={[{ required: true, message: "Fabric Usable is required" }]} name="fabricUsable"
                                                            label="Fabric Usable"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Select
                                                                size="small"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                                
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                                defaultValue={formState === "edit" ? form.getFieldValue().fabricUsable : null}
                                                                onChange={(e) => setFabricUsableID(Number(e))}
                                                                className="w-100"
                                                            
                                                            >
                                                                {
                                                                    fabricUsable?.payload?.data.map((item) => {
                                                                        return <Option disabled={!item.is_active} key={item.fabric_usable_id} value={item.fabric_usable_id}>{item.fabric_usable_name}</Option>
                                                                    })
                                                                }
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                                <div className='customCol slc width400'>
                                                    <div className="relative" >
                                                        <Form.Item rules={[{ required: true, message: "Fabric Composition is required" }]} name="fabricComposition"
                                                            label="Fabric Composition"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Select
                                                                size="small"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                filterSort={(optionA, optionB) =>
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                                }
                                                                
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                                defaultValue={formState === "edit" ? form.getFieldValue().fabricComposition : null}
                                                                onChange={(e) => setFabricCompositionID(Number(e))}
                                                                className="w-100"
                                                            
                                                            >
                                                                {
                                                                    fabricComposition?.payload?.data.map((item) => {
                                                                        return <Option disabled={!item.is_active} key={item.fabric_composition_id} value={item.fabric_composition_id}>{item.composition_name}</Option>
                                                                    })
                                                                }
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                                <div className='customCols slc width400 m-0'>
                                                    <Form.Item
                                                        label="Active"
                                                        name="active"
                                                        labelCol={{ span: 10 }}
                                                        wrapperCol={{ span: 14 }}
                                                    >
                                                        <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Form>
                                        <div className='modalStyle' >

                                            {fabricObj === null ?
                                                <Tooltip title="Please select style first" color="#fbfbfb"  >
                                                    <Button disabled={fabricObj === null ? true : false} className='' onClick={showModal} >Assign Companies</Button>
                                                </Tooltip>
                                                : <Button type="primary" className='modalButton' onClick={showModal} >Assign Companies</Button>}

                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                                <TabPane tab="Companies" key="1">
                                                    <div className='tabs' >
                                                        <Tables
                                                            type="company" scroll={340} scrollX={"25rem"}
                                                            source={(formState === "add") ? getDemoDefaultCompany?.payload?.data : (formState === "edit" || formState === "view" ? companyAccess?.payload?.data : [])}
                                                            loading={(formState === "add") ? getDemoDefaultCompany.loading : companyAccess.loading} col={companyCol} />
                                                    </div>
                                                </TabPane>
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                        <div className='modalForm' >
                                            <Modal
                                                title="Assign Companies"
                                                visible={visible}
                                                onOk={handleOk}
                                                onCancel={handleCancel}
                                                footer={null}
                                            >
                                                <Tables type="companyAccess" scroll={334} perPage={12} source={companyAll?.payload?.data} col={companyAccessCol} load={companyAll.loading} />
                                            </Modal>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}